import { ContentContext, LocaleContext, RegionContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CovidTrackerHeadlines from '@reuters-graphics/covid-tracker-headlines';
import Headlines from './Headlines';
import Status from './Status';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const atlas = new AtlasMetadataClient();

const HeadlineNews = ({ stepDuration = 750, delay = 100, globalStatistics, hasFetched }) => {
  const locale = useContext(LocaleContext);
  const region = useContext(RegionContext);
  const content = useContext(ContentContext);

  const covidTrackerHeadlines = new CovidTrackerHeadlines({
    globalStatistics: globalStatistics,
    smartText: content.common.headlines,
    locale,
    include: atlas.getRegion(region).countries.map(c => c.isoAlpha2),
  });

  const headlines = covidTrackerHeadlines.getHeadlines(3);

  if (headlines.length === 0) return null;

  return (
    <div className={classnames(component)}>
      <div className='headline-well clearfix'>
        <Status
          delay={headlines.length * stepDuration + delay}
          hasFetched={hasFetched}
        />
        {
          hasFetched && (
            <Headlines
              stepDuration={stepDuration}
              delay={delay}
              headlines={headlines}
              hasFetched={hasFetched}
              lastUpdated={globalStatistics.lastUpdated}
            />
          )
        }
      </div>
    </div>
  );
};

export default HeadlineNews;
